import type { ChartOfAccount } from '@clockwise/clients/chart-of-accounts';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { chartOfAccountsApi } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * The whole chart of accounts. Read-only and small (dozens of rows), so every
 * picker shares one cached fetch rather than searching the server. Changes only
 * when the chart is reloaded, hence the long stale time.
 */
export function useChartOfAccounts() {
  const query = useQuery({
    queryKey: queryKeys.chartOfAccounts.all,
    queryFn: () => chartOfAccountsApi.list(),
    staleTime: 5 * 60_000,
  });
  const accounts = query.data?.data;
  const byId = useMemo(
    () => new Map<string, ChartOfAccount>((accounts ?? []).map((a) => [a.id, a])),
    [accounts],
  );
  return { ...query, accounts: accounts ?? [], byId };
}
